window.customCartDrawerEvents =
  window.customCartDrawerEvents ||
  function () {
    let applyBtn = document.querySelector("#apply-discount-btn"),
      discountCodeError = document.querySelector("#discount-code-error"),
      discountCodeSuccess = document.querySelector("#discount-code-success"),
      discountLabel = document.querySelector("#discount-label"),
      discountCodeLabelValue = document.querySelector("#discount-title"),
      discountCodePrice = document.querySelector(
        ".applied-discount-code-price",
      ),
      discountFinalPrice = document.querySelector("#discounted-price"),
      discountCodeInput = document.querySelector("#discount-code-input"),
      totalCartSelector = document.querySelector("#total-price"),
      checkoutContainer = document.createElement("div"),
      remove_promobutton = document.querySelector("#remove-discount-btn")

    let authorization_token

    // Append checkout container to the body
    // document.body.appendChild(checkoutContainer);

    // Add click event listener to the apply button
    if (applyBtn) {
      applyBtn.addEventListener("click", function (e) {
        e.preventDefault()
        applyBtn.innerHTML =
          "<div class='loader loading__spinner'><svg aria-hidden='true' focusable='false' class='spinner' viewBox='0 0 66 66' xmlns='http://www.w3.org/2000/svg'><circle class='path' fill='none' stroke-width='6' cx='33' cy='33' r='30'></circle></svg></div>"
        applyDiscount(discountCodeInput.value)
      })
    }

    if (remove_promobutton) {
      remove_promobutton.addEventListener("click", function (e) {
        e.preventDefault()
        // applyBtn.innerHTML =
        //   "<div class='loader loading__spinner'><svg aria-hidden='true' focusable='false' class='spinner' viewBox='0 0 66 66' xmlns='http://www.w3.org/2000/svg'><circle class='path' fill='none' stroke-width='6' cx='33' cy='33' r='30'></circle></svg></div>"
        console.log("remove discount")
        clearDiscount()
        document.cookie =
          "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
        let updates = {
          discount_allocations: [],
          discounts: [],
        }
        fetch("/cart.js")
          .then((response) => response.json())
          .then((cart) => {
            // Define your Storefront API endpoint and token
            const endpoint =
              window.Shopify.routes.root + "api/2024-07/graphql.json"
            const storefrontToken = API_KEY.privateAppKey

            // Function to update cart with discount codes
            async function updateCartDiscountCodes(cartId, discountCodes) {
              const query = `
              mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]!) {
                cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
                  cart {
                    id
                    discountCodes {
                      code
                      applicable
                    }
                  }
                  userErrors {
                    field
                    message
                  }
                }
              }
            `

              const variables = {
                cartId,
                discountCodes,
              }

              try {
                const response = await fetch(endpoint, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "X-Shopify-Storefront-Access-Token": storefrontToken,
                  },
                  body: JSON.stringify({ query, variables }),
                })

                const result = await response.json()
                if (result.errors) {
                  console.error("GraphQL Errors:", result.errors)
                } else if (
                  result.data.cartDiscountCodesUpdate.userErrors.length
                ) {
                  console.error(
                    "User Errors:",
                    result.data.cartDiscountCodesUpdate.userErrors,
                  )
                } else {
                  console.log("Updated Cart:")
                  localStorage.removeItem("discount_custom_code")
                  // updateCartDrawer("remove")
                }
              } catch (error) {
                console.error("Network Error:", error)
              }
            }
            // Example usage
            const cartId = "gid://shopify/Cart/" + cart.token
            const discountCodes = []
            updateCartDiscountCodes(cartId, discountCodes)
          })
          .catch((error) => {
            alert(error.message)
          })
      })
    }

    // ---------------------------------------------------------------------------
    // Money format handler
    // ---------------------------------------------------------------------------
    Shopify.money_format = "${{amount}}"
    Shopify.formatMoney = function (cents, format) {
      if (typeof cents == "string") {
        cents = cents.replace(".", "")
      }
      var value = ""
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
      var formatString = format || this.money_format

      function defaultOption(opt, def) {
        return typeof opt == "undefined" ? def : opt
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 0)
        thousands = defaultOption(thousands, ",")
        decimal = defaultOption(decimal, ".")

        if (isNaN(number) || number == null) {
          return 0
        }

        number = (number / 100.0).toFixed(precision)

        var parts = number.split("."),
          dollars = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            "$1" + thousands,
          ),
          cents = parts[1] ? decimal + parts[1] : ""

        return dollars + cents
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2)
          break
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0)
          break
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",")
          break
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",")
          break
      }

      return formatString.replace(placeholderRegex, value)
    }

    function resetDiscountInput() {
      if (discountCodeInput) {
        // discountCodeInput.value = '';
      }
    }

    function clearDiscount() {
      if (discountLabel) discountLabel.classList.add("disp-none")
      if (discountFinalPrice) discountFinalPrice.classList.add("disp-none")
      if (discountCodePrice) discountCodePrice.classList.add("disp-none")
      if (totalCartSelector) {
        totalCartSelector.classList.remove("disp-none")
        totalCartSelector.textContent =
          JSON.parse(localStorage.discountCode).totalCart +
          " " +
          Shopify.currency.active
      }
      resetDiscountInput()
      clearLocalStorage()
    }

    function clearLocalStorage() {
      localStorage.removeItem("discountCode")
    }

    function applyDiscount(code) {
      // localStorage.setItem("discount_custom_code", code)
      if (applyBtn) {
        applyBtn.innerHTML =
          "<div class='loader loading__spinner'><svg aria-hidden='true' focusable='false' class='spinner' viewBox='0 0 66 66' xmlns='http://www.w3.org/2000/svg'><circle class='path' fill='none' stroke-width='6' cx='33' cy='33' r='30'></circle></svg></div>"
        applyBtn.style.pointerEvents = "none"
      }

      fetch("/payments/config", { method: "GET" })
        .then((response) => response.json())
        .then((data) => {
          authorization_token = btoa(data.paymentInstruments.accessToken)
          return fetch("/cart.js", {})
        })
        .then((res) => res.json())
        .then((data2) => {
          let body = {
            checkout: {
              discount_code: code,
              line_items: data2.items,
              presentment_currency: Shopify.currency.active,
            },
          }

          return fetch("/wallets/checkouts/", {
            headers: {
              accept: "*/*",
              "cache-control": "no-cache",
              authorization: "Basic " + authorization_token,
              "content-type": "application/json, text/javascript",
              pragma: "no-cache",
              "sec-fetch-dest": "empty",
              "sec-fetch-mode": "cors",
              "sec-fetch-site": "same-origin",
            },
            referrerPolicy: "strict-origin-when-cross-origin",
            method: "POST",
            mode: "cors",
            credentials: "include",
            body: JSON.stringify(body),
          })
        })
        .then((response) => response.json())
        .then((data3) => {
          if (data3.checkout && data3.checkout.applied_discounts.length > 0) {
            // let discountApplyUrl =
            //   "/discount/" + code + "?v=" + Date.now() + "&redirect=/checkout/"

            // fetch(discountApplyUrl, {}).then((response) => response.text())

            if (totalCartSelector) totalCartSelector.classList.add("disp-none")
            if (discountLabel) discountLabel.classList.remove("disp-none")
            if (discountCodeError) discountCodeError.textContent = ""
            if (discountCodeSuccess) discountCodeSuccess.textContent = ""
            if (discountCodePrice) {
              discountCodePrice.classList.remove("disp-none")
              discountCodePrice.textContent =
                " -" +
                data3.checkout.applied_discounts[0].amount +
                " " +
                Shopify.currency.active
            }
            if (discountFinalPrice) {
              discountFinalPrice.classList.remove("disp-none")
              discountFinalPrice.textContent =
                data3.checkout.total_price + " " + Shopify.currency.active
            }
            if (discountCodeLabelValue) {
              discountCodeLabelValue.textContent =
                data3.checkout.applied_discounts[0].title
            }

            let localStorageValue = {
              code: code.trim(),
              totalCartDisount: data3.checkout.total_price,
              totalCart: data3.checkout.total_line_items_price,
            }
            localStorage.setItem(
              "discountCode",
              JSON.stringify(localStorageValue),
            )
            localStorage.setItem("discount_custom_code", code)
            resetDiscountInput()
            discountCodeSuccess.textContent = `Promo code "${discountCodeInput.value}" successfully added.`
            document.querySelector("#discount-code-success").style.display =
              "block"
            document
              .querySelector(".cart-discount")
              .classList.add("success-message")
            document
              .querySelector(".cart-discount")
              .classList.remove("error-message")
            dataLayer.push({
              event: "promo_code_success",
              page_location: window.location.href,
            })

            // refresh page to show new discount prices
            // setTimeout(function () {
            //   location.reload()
            // }, 1000)
            fetch(`/discount/${discountCodeInput.value}`)
              .then((response) => {
                if (response.ok) {
                  return fetch("/cart.js") // Fetch the updated cart with discount applied
                } else {
                  throw new Error("Discount code is invalid or expired")
                }
              })
              .then((response) => response.json())
              .then((cart) => {
                // updateCartDrawer("add")
              })
              .catch((error) => {
                alert(error.message)
              })
              .finally(() => {
                if (applyBtn) {
                  applyBtn.textContent = "Apply"
                  applyBtn.style.pointerEvents = "all"
                }
              })
          } else {
            if (discountCodeError) {
              if (discountCodeInput.value != "") {
                discountCodeError.textContent = `Promo code "${discountCodeInput.value}" cannot currently be added to your cart.`
              } else {
                discountCodeError.textContent = `Please add a Promo Code.`
              }
              localStorage.removeItem("discountCode")
              localStorage.removeItem("discount_custom_code")
              document
                .querySelector(".cart-discount")
                .classList.remove("success-message")
              document
                .querySelector(".cart-discount")
                .classList.add("error-message")
            }
            clearDiscount()
          }
        })
        .finally(() => {
          if (applyBtn) {
            applyBtn.textContent = "Apply"
            applyBtn.style.pointerEvents = "all"
          }
        })
    }

    document
      .querySelectorAll(".multiple-offers input")
      .forEach(function (checkbox) {
        checkbox.addEventListener("change", function () {
          document
            .querySelectorAll(".multiple-offers input")
            .forEach(function (otherCheckbox) {
              if (otherCheckbox !== checkbox) {
                otherCheckbox.checked = false
                otherCheckbox
                  .closest(".militry-offer-code")
                  .classList.remove("active")
              } else {
                otherCheckbox
                  .closest(".militry-offer-code")
                  .classList.add("active")
              }
            })
        })
      })

    const shippingTerms = document.querySelector(".shipping-terms")
    if (shippingTerms) {
      shippingTerms.addEventListener("click", (event) => {
        const customProgressBar = event.target.closest("cart-drawer.drawer")
        const customTermsPopup = customProgressBar
          ? customProgressBar.querySelector(".show-custom-terms-popup")
          : null
        if (customTermsPopup) {
          customTermsPopup.classList.add("active")
        }
      })
    }

    const termsPopupClose = document.querySelector(".terms-popup-close")
    if (termsPopupClose) {
      termsPopupClose.addEventListener("click", (event) => {
        let customProgressBar = event.target.closest("cart-drawer.drawer")
        if (customProgressBar) {
          let customTermsPopup = customProgressBar.querySelector(
            ".show-custom-terms-popup",
          )
          if (customTermsPopup) {
            customTermsPopup.classList.remove("active")
          }
        }
      })
    }
  }

window?.customCartDrawerEvents?.()
